import { lowerCase, startCase } from 'lodash';
import Vue from 'vue';

Vue.filter('titlecase', function (value: string) {
  return startCase(lowerCase(value));
});
